module.exports = __webpack_public_path__ + "static/media/user-guide-2.3b51dfd5.png";